import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

/**
 * Komponente zur Darstellung einer RadioGroup
 *
 * @param label die Überschrift
 * @param options die Auswahlmöglichkeiten
 * @param optionTitle die anzuzeigende Property der option
 * @param optionKey der zu verwendende eindeutige key der option
 * @param required
 * @param error
 * @param rest zusätzliche Parameter wie u.A.:
 * <ul>
 *     <li>row - zur horizontalen Darstellung</li>
 * </ul>
 * @returns {JSX.Element}
 * @constructor
 */
function EARadioGroup({ label, options, optionTitle, optionKey, required, error, ...rest }) {
    return (
        <FormControl required={required} error={!!error}>
            <RadioGroup name="gender1" {...rest}>
                <FormLabel required={required} error={!!error}>
                    {label}
                </FormLabel>
                {options.map((option) => createOption(option, optionTitle, optionKey))}
            </RadioGroup>
            {error && (
                <FormHelperText id={label + "-helper-text"} error>
                    {error}
                </FormHelperText>
            )}
        </FormControl>
    );
}

function createOption(option, optionTitleProperty, optionKeyProperty) {
    const optionTitle = optionTitleProperty ? option[optionTitleProperty] : option;
    const optionKey = optionKeyProperty ? option[optionKeyProperty] : optionTitle;
    return <FormControlLabel key={optionKey} value={optionKey} control={<Radio color="primary" />} label={optionTitle} />;
}

export default EARadioGroup;
